<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "Initial State of Charge" chart.
    </rb-callout>
</div>
<div id="soc-start-chart"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container ">
        Distribution of initial state of charge per charging session.
    </div>
</div>
